import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { colors, fontSize } from '../../../constants/styleConstants';
import Button from '../../../components/Button';
import EditModeCard, { EditModeCardSection } from '../../../components/EditModeCard';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 'bold',
    color: colors.cardTitle,
    fontSize: '15px',
    marginBottom: theme.spacing(1),
  },
  applyButton: {
    fontSize: fontSize.medium,
    display: 'block',
    fontWeight: 'bold',
    padding: '2px 15px',
    marginTop: theme.spacing(1),
  },
}));

const BulkBox = ({ title, buttonText, children, applyFunc }) => {
  const classes = useStyles();
  return (
    <EditModeCard className={classes.root}>
      <EditModeCardSection first>
        <div className={classes.title}>{title}</div>
        {children}
        <Button className={classes.applyButton} onClick={applyFunc}>
          {buttonText}
        </Button>
      </EditModeCardSection>
    </EditModeCard>
  );
};

BulkBox.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonText: PropTypes.string.isRequired,
  children: PropTypes.node,
  applyFunc: PropTypes.func.isRequired,
};

export default BulkBox;
